import { ResidenceEntity } from '../entities/residence-entity';

export default class State {
  items: Array<ResidenceEntity> = [];
}
